// HERO IMAGE MARQUEE -- START
$('.hero_img_marquee').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    dots: false,
    arrows: false,
    autoplaySpeed: 0,
    speed: 8000,
    pauseOnHover: false,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 9999,
        settings: "unslick"
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
        }
      }
    ]
});
// HERO IMAGE MARQUEE -- END

// LOGO MARQUEE -- START

$('.logo_marquee_slider').slick({
  slidesToShow: 6,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 8000,
  pauseOnHover: false,
  arrows: false,
  dots: false,
  cssEase: 'linear',
  responsive: [
    {
      breakpoint: 1240,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
  ]
});

// LOGO MARQUEE -- END

// MOBILE MENU ICON HIDE -- START
jQuery(document).on("click",".sub__menu__link",function(e){
  jQuery('.close_btn_menu').addClass('parent_menu_open');
});
jQuery(document).on("click",".sub_menu__back",function(e){
  setTimeout(function(){
    jQuery('.close_btn_menu').removeClass('parent_menu_open');
  },250);  
});
// MOBILE MENU ICON HIDE -- END


// REVIEWS SLIDER -- START
$('.reviews__slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    dots: true,
    arrows: true,
    prevArrow:'<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M20.5465 9.88L14.4398 16L20.5465 22.12L18.6665 24L10.6665 16L18.6665 8L20.5465 9.88Z" fill="#040F30"/></svg></button>',
    nextArrow:'<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M11.4535 9.88L17.5602 16L11.4535 22.12L13.3335 24L21.3335 16L13.3335 8L11.4535 9.88Z" fill="#040F30"/></svg></button>',
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 850,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          infinite: true,
          arrows: false,
          centerMode: true,
        }
      }
    ]
});
// REVIEWS SLIDER -- END

// COLLECTION TABING -- START
$(document).ready(function () {
  jQuery(".cl_main_tabs li").eq(0).addClass("current");
  jQuery(".tabs-content").find(".cl_maintab-content").eq(0).addClass("current");
  $("ul.cl_main_tabs li").click(function () {
    var tab_id = $(this).attr("data-tab");

    $("ul.cl_main_tabs li").removeClass("current");
    $(".cl_maintab-content").removeClass("current");

    $(this).addClass("current");
    $("#" + tab_id).addClass("current");
    $(".producttab-itemslick").slick("refresh");
  });
});
// COLLECTION TABING -- END

// SOCIAL MEDIA SCROLL -- START
$(".social-media-scrollbar").slick({
  slidesToShow: 8,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 8000,
  pauseOnHover: false,
  infinite: true,
  cssEase: "linear",
  responsive: [
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
  ],
});
// SOCIAL MEDIA SCROLL -- END

// FAQ HOME -- START
$(document).ready(function () {
  $(".home-set > a").on("click", function (e) {
    e.preventDefault();

    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings(".home-content").slideUp(200);
      $(this).find("i").removeClass("fa-minus").addClass("fa-plus");
    } else {
      $(".home-set > a").removeClass("active");
      $(".home-content").slideUp(200);
      $(".home-set > a i").removeClass("fa-minus").addClass("fa-plus");

      $(this).addClass("active");
      $(this).siblings(".home-content").slideDown(200);
      $(this).find("i").removeClass("fa-plus").addClass("fa-minus");
    }
  });

  // faq page
  $(".new-set > a").on("click", function (e) {
      e.preventDefault();

      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this).siblings(".new-content").slideUp(200);
        $(this).find("i").removeClass("fa-minus").addClass("fa-plus");
      } else {
        $(".new-set > a").removeClass("active");
        $(".new-content").slideUp(200);
        $(".new-set > a i").removeClass("fa-minus").addClass("fa-plus");

        $(this).addClass("active");
        $(this).siblings(".new-content").slideDown(200);
        $(this).find("i").removeClass("fa-plus").addClass("fa-minus");
      }
    });
  
});
// FAQ HOME -- END

// COMPARE SLIDER -- START
$('.compare__slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    dots: true,
    arrows: true,
    prevArrow:'<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M20.5465 9.88L14.4398 16L20.5465 22.12L18.6665 24L10.6665 16L18.6665 8L20.5465 9.88Z" fill="#040F30"/></svg></button>',
    nextArrow:'<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M11.4535 9.88L17.5602 16L11.4535 22.12L13.3335 24L21.3335 16L13.3335 8L11.4535 9.88Z" fill="#040F30"/></svg></button>',
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 850,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerPadding: "30px",
          infinite: true,
          arrows: false,
          centerMode: true,
        }
      }
    ]
});
// COMPARE SLIDER -- START

// Collection Page Tab Active -- Start
$(document).ready(function () {
    // Get the current URL
    var url = window.location.href;

    // Split the URL by '/' and get the last part
    var lastParam = url.split('/').pop();
    var $this = jQuery('.cb_list_link[href="'+lastParam+'"]');
    
    // Remove 'active' class from all tabs and add to clicked one
    jQuery('.cb_list_item').removeClass("active");
    $this.parent().addClass("active");
  // Move the clicked tab to the first position
    jQuery('.cb_list_link[href="'+lastParam+'"]').parent().parent('div').prependTo(".collection_bubble_box");
});

// Collection Page Tab Active -- End

// Product Recommendation -- Start
$(document).ready(function () {
  $("ul.pr_tabs_titles li").click(function () {
    var tab_id = $(this).attr("data-tab");

    $("ul.pr_tabs_titles li").removeClass("current");
    $(".pr_tab_content").removeClass("current");

    $(this).addClass("current");
    $("#" + tab_id).addClass("current");
  });
});
// Product Recommendation -- END
/************************ ANNOUNCEMENT TIMER JS START **************************/
jQuery(document).ready(function () {
  function getNetherlandsTime() {
    // Get the current date and time in Netherlands timezone
    const nlDateTimeString = new Date().toLocaleString(undefined, {
      timeZone: "Europe/Amsterdam",
    });

    // Parse the date and time string
    const [date, time] = nlDateTimeString.split(", ");
    const [month, day, year] = date.split("/");
    const [hour, minute, second] = time.split(/:| /);

    // Create a Date object for Netherlands time
    const isPM = time.includes("PM");
    const hour24 = isPM && hour !== "12" ? parseInt(hour) + 12 : parseInt(hour);
    return new Date(year, month - 1, day, hour24, minute, second);
  }

  function updateTimer() {
    const currentNL = getNetherlandsTime();

    // Calculate the next Sunday midnight in Netherlands
    const day = currentNL.getDay();
    const daysUntilSunday = 7 - day;
    const nextSundayMidnight = new Date(currentNL);
    nextSundayMidnight.setDate(currentNL.getDate() + daysUntilSunday);
    nextSundayMidnight.setHours(0, 0, 0, 0);

    // Calculate the time difference in milliseconds
    const timeDiff = nextSundayMidnight - currentNL;

    // Convert the difference into hours, minutes, and seconds
    const seconds = Math.floor((timeDiff / 1000) % 60);
    const minutes = Math.floor((timeDiff / (1000 * 60)) % 60);
    const hours = Math.floor((timeDiff / (1000 * 60 * 60)) % 24);

    // Update the timer display
    $(".abar-timer .abar-hours").text(`${hours.toString().padStart(2, "0")}`);
    $(".abar-timer .abar-minutes").text(`${minutes.toString().padStart(2, "0")}`);
    $(".abar-timer .abar-seconds").text(`${seconds.toString().padStart(2, "0")}`);
  }

  // Update the timer every second
  setInterval(updateTimer, 1000);

  // Run the update immediately on load
  updateTimer();
});

/************************ ANNOUNCEMENT TIMER JS End **************************/

/************************ landing featured product JS START **************************/
jQuery(document).ready(function() {
  jQuery(".fp-accordian > .fp-accordian-heading").on("click", function() {
    if (jQuery(this).hasClass("active")) {
      jQuery(this).removeClass("active");
      jQuery(this)
        .siblings(".fp-accordian-content")
        .slideUp(200);
      jQuery(".fp-accordian > .fp-accordian-heading i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    } else {
      jQuery(".fp-accordian > .fp-accordian-heading i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      jQuery(this)
        .find("i")
        .removeClass("fa-plus")
        .addClass("fa-minus");
      jQuery(".fp-accordian > .fp-accordian-heading").removeClass("active");
      jQuery(this).addClass("active");
      jQuery(".fp-accordian-content").slideUp(200);
      jQuery(this)
        .siblings(".fp-accordian-content")
        .slideDown(200);
    }
  });
});

/************************ landing featured product JS END **************************/

// LANDING STICKY -- START
if(jQuery('.listicle_steps').length!=0){
  jQuery(window).scroll(function(){
  var buttonHeight = parseInt(jQuery('.listicle_steps').offset().top);
    console.log("height",buttonHeight);
    console.log("scroll",jQuery(this).scrollTop());
    if (jQuery(this).scrollTop() > buttonHeight) {
		jQuery('.landing-sticky-section').show();
	}else{
        jQuery('.landing-sticky-section').hide();
    }                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  
  });
}
if(jQuery('.sticky_show_bar').length!=0){
  jQuery(window).scroll(function(){
  var buttonHeight = parseInt(jQuery('.sticky_show_bar').offset().top);
    console.log("height",buttonHeight);
    console.log("scroll",jQuery(this).scrollTop());
    if (jQuery(this).scrollTop() > buttonHeight) {
		jQuery('.landing-sticky-section').show();
	}else{
        jQuery('.landing-sticky-section').hide();
    }                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  
  });
}
// LANDING STICKY -- END

// ADVERTORIAL FAQ -- START
document.addEventListener("DOMContentLoaded", function () {
  const accordionItemHeaders = document.querySelectorAll(".ad_faq-item-header");

  accordionItemHeaders.forEach((accordionItemHeader) => {
    accordionItemHeader.addEventListener("click", (event) => {
      const currentlyActiveAccordionItemHeader = document.querySelector(
        ".ad_faq-item-header.active"
      );
      
      // Only close the currently active item if it's different from the clicked one
      if (
        currentlyActiveAccordionItemHeader &&
        currentlyActiveAccordionItemHeader !== accordionItemHeader
      ) {
        currentlyActiveAccordionItemHeader.classList.remove("active");
        const currentlyActiveAccordionItemBody = currentlyActiveAccordionItemHeader.nextElementSibling;
        if (currentlyActiveAccordionItemBody) {
          currentlyActiveAccordionItemBody.style.maxHeight = 0;
        }
      }

      // Toggle the active class and manage the nextElementSibling
      accordionItemHeader.classList.toggle("active");
      const accordionItemBody = accordionItemHeader.nextElementSibling;
      
      if (accordionItemBody) {
        if (accordionItemHeader.classList.contains("active")) {
          accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px";
        } else {
          accordionItemBody.style.maxHeight = 0;
        }
      }
    });
  });
});

// ADVERTORIAL FAQ -- END

// ADVERTORIAL LOGO MARQUEE -- START

$('.al__marquee_slider').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  dots: false,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 8000,
  pauseOnHover: false,
  variableWidth: true,
  cssEase: 'linear'
});

// ADVERTORIAL LOGO MARQUEE -- END

//swatch change for discount label change text start

jQuery(document).on("change", ".sr-only", function () {
  var getOffVal = jQuery(this).next('.block-swatch').find(".cus_variant_saveprice").text().trim();
  var saveLabel = jQuery(this).attr('data-savinglable');
  // Extract numeric value
  getOffVal = getOffVal.replace(/\D/g, "");

  // Debugging
  console.log("Savings:", getOffVal);

  if (getOffVal) {
    jQuery('.price_list_saveprice')
      .show()
      .text(saveLabel+' ' + getOffVal + '%')
      .attr('data-savings', getOffVal + '%'); // Update data-savings attribute
  } else {
    jQuery('.price_list_saveprice').hide();
  }
});
/*
jQuery(document).on("change",".sr-only",function(){
  var getOffVal = jQuery(this).next('.block-swatch').find(".cus_variant_saveprice").text();
  getOffVal = getOffVal.replace(/\D/g, "");
  $('.price_list_saveprice').hide();
  if(getOffVal){
    $('.price_list_saveprice').show();
  }
  jQuery('.product_page_container').find('.product-info__price .price_list_saveprice').text('redden '+getOffVal+'%');
  jQuery('.product-quick-add__variant').find('.price_list_saveprice').text('redden '+getOffVal+'%');
});
*/

//swatch change for discount label change text end


$('.add__select_custom_cart').change(function() {
  var vPrice = $(this).find('option:selected').attr('data-price');
  var vcPrice = $(this).find('option:selected').attr('data-comprice');
  var vImg = $(this).find('option:selected').attr('data-vimg');
  $(this).closest('.cdupsell-product').find('.cdupsell-product-media').find('img').attr('src', vImg);
  $('.cdupsell-comparesale').hide();
  if(vcPrice != ''){
    $('.cdupsell-comparesale').show();
    $(this).closest('.cdupsell-product-info').find('.cdupsell-comparesale').html(vcPrice);
  }
  $(this).closest('.cdupsell-product-info').find('.cdupsell-sale').html(vPrice);
});



/**********************************************************************************
  PRODUCT DETAILS PAGE FOR STICKY BAR ADD TO CART VARIANT SELECTED WISE JS START
**********************************************************************************/
// sticky button click to trigger main atc button
jQuery(document).on("click", ".product-quick-add-custom .pc_variant_btn .sticky__btn", function(){
  jQuery('.product-info__buy-buttons').find('.buy-buttons').find('.button').trigger('click');
  if(jQuery('.product-quick-add.product-quick-add-custom').find('.button.sticky__btn').length>0){
    jQuery('.product-quick-add.product-quick-add-custom').find('.button.sticky__btn').addClass('active');
    setTimeout(function(){
      jQuery('.product-quick-add.product-quick-add-custom').find('.button.sticky__btn').removeClass('active');
    },3000);
  }
});
// Main variant change event
jQuery(document).on("click",".variant-picker__option-values [type='radio']",function(e){
  if(jQuery('.product-quick-add-custom').find('.sticky-product-variant').length>0){
    var getSelectedVariant = prepareVariantHandle();
    jQuery('.product-quick-add-custom').find('.sticky-product-variant option').removeAttr('selected');
    jQuery('.product-quick-add-custom').find('.sticky-product-variant option[data-value="'+getSelectedVariant+'"]').attr('selected',true);
  }
});
//Sticky dropdown change event
jQuery(document).on("change",".product-quick-add-custom .sticky-product-variant",function(){
  if(jQuery('.variant-picker__option').find('.variant-picker__option-values').length>0){
    var getSelectedValue = jQuery(this).find('option:selected').attr('data-value');
    console.log("getSelectedValue",getSelectedValue);
    if(getSelectedValue!=undefined && getSelectedValue!=""){
      selectVariantOption(getSelectedValue);
    }
  }
});
function prepareVariantHandle(){
  var variantHandle = '';
  if(jQuery('.variant-picker__option').find('.variant-picker__option-values').length>0){
    jQuery('.variant-picker__option').find('.variant-picker__option-values').find('input[type="radio"]:checked').each(function(){
      if(variantHandle!=""){
        variantHandle+=' / ';
      }
      variantHandle+=jQuery(this).val();
    });
  }
  return variantHandle;
}
function selectVariantOption(getSelectedValue){
  var splitVariant = getSelectedValue.split(' / ');
  if(jQuery('.variant-picker__option').find('.variant-picker__option-values').length>0){
    for (var b = 0; b < splitVariant.length; b++) {
      var value = splitVariant[b].trim();
      var radio = document.querySelector('.variant-picker__option input[type="radio"][value="' + value + '"]');
      if (radio) {
        radio.checked = true;
        var event = new Event('change', { bubbles: true });
        radio.dispatchEvent(event);
        var label = radio.closest('label');
        if (label) {
          label.click();
        }
      }
    }
  }
}
/**********************************************************************************
  PRODUCT DETAILS PAGE FOR STICKY BAR ADD TO CART VARIANT SELECTED WISE JS END
**********************************************************************************/